'use strict';

// https://262.ecma-international.org/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2023/IsPropertyKey.js
// module id = 92
// module chunks = 0